module.exports = __webpack_public_path__ + "static/media/upload_courses_dropzone.303c3705.png";